(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-editorial"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.q-service').forEach(root=>{
 const track=root.querySelector('.q-service-track'),cards=[...track.children],buttons=[...root.querySelectorAll('.q-service-dots button')],count=cards.length;if(count<3)return;
 const clone=card=>{const copy=card.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a,button').forEach(e=>e.tabIndex=-1);return copy};
 track.prepend(...cards.slice(-2).map(clone));track.append(...cards.slice(0,2).map(clone));
 const mark=index=>{buttons.forEach((b,i)=>i===index?b.setAttribute('aria-current','true'):b.removeAttribute('aria-current'));[...track.children].forEach((c,i)=>c.classList.toggle('q-service-active',(i-2+count)%count===index))};
 const select=(index,smooth=true)=>{const card=cards[index];mark(index);track.scrollTo({left:card.offsetLeft-track.offsetLeft-(track.clientWidth-card.clientWidth)/2,behavior:smooth?'smooth':'instant'})};
 buttons.forEach((b,i)=>b.addEventListener('click',()=>select(i)));
 track.addEventListener('scrollend',()=>{const center=track.getBoundingClientRect().left+track.clientWidth/2;const all=[...track.children];let nearest=0,distance=Infinity;all.forEach((c,i)=>{const box=c.getBoundingClientRect(),d=Math.abs(box.left+box.width/2-center);if(d<distance){nearest=i;distance=d}});const index=(nearest-2+count)%count;if(nearest<2||nearest>=count+2)select(index,false);else mark(index)});
 select(innerWidth<750?0:1,false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-footer"]) return;
  try {
    
(()=>{const footer=document.querySelector('.q-footer');const mq=matchMedia('(max-width:749px)');const sync=()=>footer?.querySelectorAll('details').forEach(d=>d.open=!mq.matches);mq.addEventListener('change',sync);sync();const popup=document.getElementById('QNewsletter');popup?.addEventListener('close',()=>{try{sessionStorage.setItem('q-newsletter-dismissed','1')}catch(e){}});try{if(!sessionStorage.getItem('q-newsletter-dismissed')&&!location.search.includes('customer_posted'))setTimeout(()=>{if(!sessionStorage.getItem('q-newsletter-dismissed')&&!document.querySelector('dialog[open],.mobile-facets__disclosure[open],.drawer.active'))popup?.showModal()},12000)}catch(e){}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-foundation"]) return;
  try {
    
document.querySelectorAll('media-gallery').forEach(gallery=>{const slider=gallery.querySelector('slider-component'),list=slider?.querySelector('ul'),controls=slider?.querySelector('.slider-buttons');if(!controls||!list)return;const items=[...list.children].filter(e=>e.id);if(items.length<2)return;const dots=document.createElement('div');dots.className='q-gallery-dots';items.forEach((item,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',item.querySelector('button')?.getAttribute('aria-label')||String(i+1));b.setAttribute('aria-current',String(i===0));b.addEventListener('click',()=>list.scrollTo({left:list.children[i].offsetLeft-list.children[0].offsetLeft,behavior:'smooth'}));dots.append(b)});controls.append(dots);let timer;list.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(()=>{const i=Math.round(list.scrollLeft/list.clientWidth);[...dots.children].forEach((b,j)=>b.setAttribute('aria-current',String(i===j)))},80)},{passive:true})});
(()=>{const init=()=>{document.querySelectorAll('.mobile-facets__details').forEach(d=>{if(d.dataset.qAccordion)return;d.dataset.qAccordion='1';d.open=true;d.classList.add('menu-opening')});document.querySelectorAll('.mobile-facets__submenu price-range').forEach(range=>{if(range.dataset.qSlider)return;range.dataset.qSlider='1';const fields=[...range.querySelectorAll('input')];if(fields.length!==2)return;const maximum=Number(fields[1].dataset.max.replaceAll(',',''));if(!Number.isFinite(maximum))return;const root=document.createElement('div');root.className='q-price-slider';const labels=document.createElement('div');labels.className='q-price-labels';root.append(labels);const currency=range.querySelector('.field-currency')?.textContent||'';const controls=fields.map((field,i)=>{const input=document.createElement('input');input.type='range';input.min='0';input.max=String(maximum);input.step='1';input.value=field.value?field.value.replaceAll(',',''):i?String(maximum):'0';input.setAttribute('aria-label',range.querySelector('label[for="'+field.id+'"]')?.textContent.trim()||String(i+1));root.append(input);return input});const show=()=>{labels.replaceChildren(...controls.map(c=>{const span=document.createElement('span');span.textContent=currency+Math.round(Number(c.value));return span}))};controls.forEach((input,i)=>{input.addEventListener('input',()=>{if(i===0&&Number(input.value)>Number(controls[1].value))input.value=controls[1].value;if(i===1&&Number(input.value)<Number(controls[0].value))input.value=controls[0].value;show()});input.addEventListener('change',()=>{fields[i].value=input.value;fields[i].dispatchEvent(new Event('input',{bubbles:true}))})});show();range.before(root)})};init();new MutationObserver(init).observe(document.querySelector('#main-collection-filters')||document.querySelector('main'),{childList:true,subtree:true})})();
document.querySelectorAll('product-modal').forEach(modal=>{const items=[...modal.querySelectorAll('.product-media-modal__content>[data-media-id]')];if(items.length<2)return;const labels=document.getElementById('QGalleryLabels');const move=direction=>{let index=items.findIndex(i=>i.classList.contains('active'));items.forEach(i=>i.classList.remove('active'));index=(index+direction+items.length)%items.length;items[index].classList.add('active')};[-1,1].forEach(direction=>{const button=document.createElement('button');button.type='button';button.className='q-zoom-arrow '+(direction<0?'q-zoom-prev':'q-zoom-next');button.textContent=direction<0?'‹':'›';button.setAttribute('aria-label',direction<0?labels.dataset.previous:labels.dataset.next);button.addEventListener('click',()=>move(direction));modal.querySelector('.product-media-modal__dialog').append(button)});modal.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();move(1)}if(e.key==='ArrowLeft'){e.preventDefault();move(-1)}})});
document.addEventListener('change',event=>{if(!event.target.matches('.mobile-facets__checkbox'))return;const drawer=event.target.closest('menu-drawer');setTimeout(()=>{if(drawer?.querySelector('details')?.open)drawer.querySelector('.mobile-facets__open-wrapper')?.click()},700)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-header"]) return;
  try {
    
(()=>{
const shell=document.querySelector('.q-header-shell');
const update=()=>shell?.classList.toggle('q-scrolled',scrollY>120);
window.addEventListener('scroll',update,{passive:true});update();
document.querySelectorAll('.q-mega-trigger').forEach(d=>{
 let closeTimer;
 const cancelClose=()=>clearTimeout(closeTimer);
 const scheduleClose=()=>{cancelClose();closeTimer=setTimeout(()=>{if(!d.matches(':hover')&&!d.contains(document.activeElement))d.open=false},300)};
 d.addEventListener('mouseenter',()=>{cancelClose();if(innerWidth>749)d.open=true});
 d.addEventListener('mouseleave',scheduleClose);
 d.addEventListener('focusin',cancelClose);
 d.addEventListener('focusout',scheduleClose);
 d.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();cancelClose();d.open=false;d.querySelector('summary').focus()}});
 document.addEventListener('click',e=>{if(!d.contains(e.target)){cancelClose();d.open=false}});
});
document.addEventListener('click',e=>{
 const open=e.target.closest('[data-q-open]');if(open)document.getElementById(open.dataset.qOpen)?.showModal();
 if(e.target.closest('[data-q-close]'))e.target.closest('dialog')?.close();
 if(e.target.tagName==='DIALOG'){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close()}
});
const modal=document.getElementById('QQuickView');
const escape=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const route=window.Shopify?.routes?.root||'/';
document.addEventListener('click',async e=>{
 const button=e.target.closest('[data-q-product],.collection .quick-add__submit[data-product-url]');if(!button)return;if(!button.dataset.qProduct)button.dataset.qProduct=new URL(button.dataset.productUrl,location.origin).pathname.split('/products/')[1];e.preventDefault();e.stopImmediatePropagation();button.disabled=true;
 try{
  const url=route+'products/'+encodeURIComponent(button.dataset.qProduct);
  const [response,htmlResponse]=await Promise.all([fetch(url+'.js'),fetch(url)]);
  if(!response.ok)throw Error('Product unavailable');
  const p=await response.json(),doc=new DOMParser().parseFromString(await htmlResponse.text(),'text/html');
  const money=c=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(c/100);
  const content=modal.querySelector('.q-quick-content');
  content.innerHTML='<div class="q-quick-layout"><div><img class="q-quick-main-image" src="'+escape(p.featured_image)+'" alt="'+escape(p.title)+'"><div class="q-quick-thumbs">'+p.images.map(src=>'<button type="button" data-photo="'+escape(src)+'"><img src="'+escape(src)+'" alt="'+escape(p.title)+'"></button>').join('')+'</div></div><div><h2>'+escape(p.title)+'</h2><p class="q-quick-price"></p><form><select id="QVariant" name="id" aria-label="'+escape(p.options.map(o=>o.name).join(' / '))+'" hidden>'+p.variants.map(v=>'<option value="'+v.id+'">'+escape(v.title)+'</option>').join('')+'</select><div class="q-quick-options">'+p.options.map((o,i)=>'<fieldset><legend>'+escape(o.name)+'</legend>'+o.values.map((v,j)=>'<label><input type="radio" name="option'+i+'" value="'+escape(v)+'" data-option="'+i+'"><span>'+escape(v)+'</span></label>').join('')+'</fieldset>').join('')+'</div><button class="q-btn" type="submit"></button><p class="q-quick-error" role="status"></p></form><div class="q-quick-description"></div><a href="'+escape(p.url)+'">'+escape(modal.dataset.view)+'</a></div></div>';
  const select=content.querySelector('select'),submit=content.querySelector('[type=submit]');
  const sync=()=>{const v=p.variants.find(v=>String(v.id)===select.value);content.querySelector('.q-quick-price').textContent=v?money(v.price):'';submit.disabled=!v?.available;submit.textContent=v?.available?modal.dataset.add:modal.dataset.sold;if(v?.featured_image?.src)content.querySelector('.q-quick-main-image').src=v.featured_image.src};
  const first=p.variants.find(v=>v.available)||p.variants[0];select.value=first.id;
  content.querySelectorAll('[data-option]').forEach(input=>{input.checked=first.options[Number(input.dataset.option)]===input.value;input.addEventListener('change',()=>{const options=p.options.map((_,i)=>content.querySelector('[name="option'+i+'"]:checked')?.value);const v=p.variants.find(v=>v.options.every((value,i)=>value===options[i]));select.value=v?.id||'';sync()})});
  sync();
  content.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>content.querySelector('.q-quick-main-image').src=b.dataset.photo));
  doc.querySelectorAll('.product__info-container .product__accordion').forEach(a=>{a.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));content.querySelector('.q-quick-description').append(a)});
  content.querySelector('form').addEventListener('submit',async event=>{
   event.preventDefault();submit.disabled=true;
   try{const cart=document.querySelector('cart-drawer');const r=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:select.value,quantity:1,sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});const result=await r.json();if(!r.ok)throw Error(result.description||modal.dataset.error);modal.close();if(cart){cart.classList.remove('is-empty');cart.renderContents(result)}else location.href=route+'cart'}
   catch(error){content.querySelector('.q-quick-error').textContent=error.message}finally{sync()}
  });
  modal.showModal();
 }catch(error){location.href=route+'products/'+encodeURIComponent(button.dataset.qProduct)}finally{button.disabled=false}
},true);
})();

  } catch(e) { console.error(e); }
})();
})();
